import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null>;

export const getStripe = () => {
  if (!stripePromise) {
    const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
    
    if (!publishableKey) {
      throw new Error(
        'NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY is not defined. Please check your .env file and ensure it contains NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY.'
      );
    }
    
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
};